import React, { useEffect, useRef, useState } from 'react';
import './Navbar.scss';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import SvgIcons from '../../services/SvgIcons';
import { getContent } from '../../services/strapi/endpoints';
import { isExternalLink } from '../../services/helpers';
import { useMediaQuery } from 'react-responsive';
import StrapiImageWithSkeleton from '../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import NavbarAuth from '../NavbarAuth/NavbarAuth';
import { jwtDecode } from "jwt-decode";
import { strapiAuthService } from '../../services/api/strapiAuth';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const isdown1080 = useMediaQuery({ maxWidth: 1080 });
    const isTab = useMediaQuery({ maxWidth: 1300 });
    const [activeMenuIndex, setActiveMenuIndex] = useState(null); // Garde en mémoire le menu actif
    const [selectedMenuIndex, setSelectedMenuIndex] = useState(null); // Pour le menu sélectionné via un clic
    const location = useLocation(); // Utilisé pour suivre le chemin actuel

    const defaultMenu = [
        {
            title: 'Accueil',
            link: ''
        },
        {
            title: 'À propos',
            link: 'a-propos'
        },
        {
            title: 'Accompagnement',
            link: 'accompagnement-individuel'
        },
        {
            title: 'Ateliers parentalité',
            link: 'ateliers-parentalite'
        },
        {
            title: 'Programmes en ligne',
            link: 'programmes-en-ligne'
        },
        {
            title: 'Freebies',
            link: 'freebies'
        },
        {
            title: 'Cercles de mamans',
            link: 'cercles-de-mamans'
        },
        {
            title: 'Blog',
            link: 'blog'
        },
    ]

    // Gestion du scroll
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        }

        // Cleanup function pour s'assurer que les styles sont réinitialisés
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        };
    }, [isMenuOpen]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = (e) => {
        setIsMenuOpen(false);
    
        // Parcourir toutes les références des sous-menus et les fermer
        submenuRefs.current.forEach((submenuRef, index) => {
            if (submenuRef) {
                submenuRef.style.height = '0'; // Réinitialiser la hauteur
                const chevronRef = chevronSubmenuRefs.current[index];
                if (chevronRef) {
                    chevronRef.style.transform = 'rotate(-90deg)';
                }
            }
        });
    
        // Réinitialiser l'état du sous-menu actif
        setActiveSubMenu(null);
    };
    

    const strapiURl = {
        page: 'navbar',
        components: [
            '[Logo][populate]=*&',
            '[LienNavigation][populate][liste_ateliers_programme][populate][Cartes_Atelier][populate]=*&',
            '[LienReseauSocial][populate]=*',
        ],
    }

    const [strapiData, setStrapiData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getContent(strapiURl);
                setStrapiData(response.data.data);
                setIsLoading(false);
            } catch (err) {
                setError(err);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [])

    const submenuRefs = useRef([]);
    const chevronSubmenuRefs = useRef([]);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const displayOrHideSubMenuMobile = (menuItem, index) => {
        if (menuItem.liste_ateliers_programme) {
            const currentSubmenuRef = submenuRefs.current[index];
            const chevronCurrentSubmenuRef = chevronSubmenuRefs.current[index]; // Ajustez le sélecteur si nécessaire
            if (activeSubMenu === index) {
                // Fermer le sous-menu actif
                currentSubmenuRef.style.height = '0';
                chevronCurrentSubmenuRef.style.transform = 'rotate(-90deg)';
                setActiveSubMenu(null); // Aucun sous-menu actif
            } else {
                // Fermer le sous-menu actuellement ouvert, s'il y en a un
                if (activeSubMenu !== null) {
                    const previousSubmenuRef = submenuRefs.current[activeSubMenu];
                    const chevronPreviousSubmenuRef = chevronSubmenuRefs.current[activeSubMenu];
        
                    previousSubmenuRef.style.height = '0';
                    chevronPreviousSubmenuRef.style.transform = 'rotate(-90deg)';
                }    
                // Ouvrir le nouveau sous-menu
                /* currentSubmenuRef.style.height = (menuItem.liste_ateliers_programme.Cartes_Atelier.length * 40 + 10) + 'px'; */
                const validItemsCount = menuItem.liste_ateliers_programme.Cartes_Atelier.filter(item => item.Bouton && item.Bouton.LienBouton !== null).length;
                currentSubmenuRef.style.height = (validItemsCount * 40 + 10 + 0) + 'px';
                chevronCurrentSubmenuRef.style.transform = 'rotate(90deg)';
                setActiveSubMenu(index); // Mettre à jour l'état
            }
        }
    };

    const displaySubMenu = (menuItem, index) => {
        if (menuItem.liste_ateliers_programme) {
            const currentSubmenuRef = submenuRefs.current[index];
            const chevronCurrentSubmenuRef = chevronSubmenuRefs.current[index]; // Ajustez le sélecteur si nécessaire
                // Fermer le sous-menu actuellement ouvert, s'il y en a un
                if (activeSubMenu !== null) {
                    const previousSubmenuRef = submenuRefs.current[activeSubMenu];
                    const chevronPreviousSubmenuRef = chevronSubmenuRefs.current[activeSubMenu];
        
                    previousSubmenuRef.style.height = '0';
                    chevronPreviousSubmenuRef.style.transform = 'rotate(-90deg)';
                }    
                // Ouvrir le nouveau sous-menu
                /* currentSubmenuRef.style.height = (menuItem.liste_ateliers_programme.Cartes_Atelier.length * 40 + 10 + 0) + 'px'; */
                const validItemsCount = menuItem.liste_ateliers_programme.Cartes_Atelier.filter(item => item.Bouton && item.Bouton.LienBouton !== null).length;
                currentSubmenuRef.style.height = (validItemsCount * 45 + 10 + 0) + 'px';
                chevronCurrentSubmenuRef.style.transform = 'rotate(90deg)';/* 
                chevronCurrentSubmenuRef.children[0].children[0].style.fill = '#AF968C'; */
                setActiveSubMenu(index); // Mettre à jour l'état
        }
    };


    const hideSubMenu = (menuItem, index) => {
        if (menuItem.liste_ateliers_programme) {
            const currentSubmenuRef = submenuRefs.current[index];
            const chevronCurrentSubmenuRef = chevronSubmenuRefs.current[index]; // Ajustez le sélecteur si nécessaire
                // Fermer le sous-menu actuellement ouvert, s'il y en a un
                if (activeSubMenu !== null) {
                    const previousSubmenuRef = submenuRefs.current[activeSubMenu];
                    const chevronPreviousSubmenuRef = chevronSubmenuRefs.current[activeSubMenu];
        
                    previousSubmenuRef.style.height = '0';
                    chevronPreviousSubmenuRef.style.transform = 'rotate(-90deg)';
                    /* chevronCurrentSubmenuRef.children[0].children[0].style.fill = '#361215'; */
                }
        }
    };

    // Au chargement du composant et à chaque changement d'URL
    useEffect(() => {
        // Réinitialiser le menu sélectionné manuellement
        setSelectedMenuIndex(null);

        // Fermer tous les sous-menus quand on change de page
        submenuRefs.current.forEach((submenuRef, index) => {
            if (submenuRef) {
                submenuRef.style.height = '0';
                const chevronRef = chevronSubmenuRefs.current[index];
                if (chevronRef) {
                    chevronRef.style.transform = 'rotate(-90deg)';
                }
            }
        });
        setActiveSubMenu(null);
    }, [location.pathname]);

    
    // Fonction pour déterminer si le lien est actif de façon plus précise
    const isLinkActive = (menuItem) => {
        if (menuItem.LienNavigation === null) {
            return location.pathname === '/';
        }
        
        // Vérifier si le chemin correspond directement
        if (location.pathname === '/' + menuItem.LienNavigation) {
            return true;
        }
        
        // Vérifier si le chemin correspond à un élément du sous-menu
        if (menuItem.liste_ateliers_programme && menuItem.liste_ateliers_programme.Cartes_Atelier) {
            return menuItem.liste_ateliers_programme.Cartes_Atelier.some(subItem => 
                subItem.Bouton && 
                subItem.Bouton.LienBouton && 
                !isExternalLink(subItem.Bouton.LienBouton) &&
                location.pathname === '/' + subItem.Bouton.LienBouton
            );
        }
        
        return false;
    };
    
    const handleLogout = () => {
        logout();  // logout du context
        navigate('/');
    };

    if (error || !strapiData || isLoading) return (
        <nav className="navbar">
            <div className="navbar__container">
                <div className="navbar__logo">
                    <NavLink
                        to="/"
                        className="navbar__logo_link"
                        onClick={closeMenu}
                    >
                        {
                            error &&
                                <StrapiImageWithSkeleton
                                    url='/assets/logo-whiteBkg.png'
                                    altPicture="Logo Grandir & s'élever ensemble"
                                    borderRadius='50%'
                                    breakpoints={
                                        [
                                            { b: 0, w: '59px', h: '59px' },
                                        ]
                                    }
                                />
                        }
                    </NavLink>
                </div>
                <button
                    className="navbar__burger"
                    onClick={toggleMenu}
                    aria-expanded={isMenuOpen}
                    aria-label="Menu principal"
                >
                    {isMenuOpen ? (
                        <SvgIcons name="close" width="36" height="36" color="#36152F" />
                    ) : (
                        <SvgIcons name="burger_menu" width="48" height="48" color="#36152F" />
                    )}
                </button>

                <div className={`navbar__menu ${isMenuOpen ? 'active' : ''}`}>
                    <ul className='navbar__menu_navigation_list'>
                        {
                            defaultMenu.map((menuItem, index) => (
                                <li
                                    key={index}
                                    className='navbar__menu_navigation_item'
                                >
                                    <NavLink
                                        to={'/' + menuItem.link}
                                        className={({ isActive }) =>
                                            isActive ? "navbar__link active" : "navbar__link"
                                        }
                                        onClick={closeMenu}
                                    >
                                        <span>{menuItem.title}</span>
                                        {
                                            (menuItem.link === 'ateliers-parentalite' || menuItem.link === 'programmes-en-ligne') &&
                                            <svg
                                                ref={(e) => (chevronSubmenuRefs.current[index] = e)}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation(); // Empêche la propagation du clic au NavLink
                                                    displayOrHideSubMenuMobile(menuItem, index);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={isMobile ? 25 : (isTab ? 20 : 25)}
                                                height={isMobile ? 25 : (isTab ? 20 : 25)}
                                                viewBox="0 -960 960 960"
                                                fill="currentColor"
                                            >
                                                <path strokeWidth='10px' stroke='currentColor' d="M622-136.5 278.5-480 622-823.5l29 28.5-315 315 315 314.5-29 29Z" />
                                            </svg>
                                        }
                                    </NavLink>
                                </li>
                            ))
                        }
                    </ul>
                    <div className="navbar__social navbar__social--mobile">
                        <a href="http://instagram.com/grandiretseleverensemble/"
                            className="navbar__social__link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {
                                error &&
                                    <StrapiImageWithSkeleton
                                        url= '/assets/instagram.webp'
                                        altPicture= "Logo instagram"
                                        className='navbar__social__link__img'
                                        breakpoints={
                                            [
                                                { b: 0, w: '45px', h: '45px' },
                                                { b: 480, w: '32px', h: '32px' },
                                                { b: 1080, w: '40px', h: '40px' },
                                            ]
                                        }                                   
                                    />
                            }
                        </a>
                        <a href="https://www.facebook.com/grandiretseleverensemble/"
                            className="navbar__social__link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {
                                error &&
                                    <StrapiImageWithSkeleton
                                        url='/assets/facebook.webp'
                                        altPicture="Logo facebook"
                                        className='navbar__social__link__img'
                                        breakpoints={
                                            [
                                                { b: 0, w: '45px', h: '45px' },
                                                { b: 480, w: '32px', h: '32px' },
                                                { b: 1080, w: '40px', h: '40px' },
                                            ]
                                        }
                                    />
                            }
                        </a>
                    </div>

                    <div className="navbar__navbarAuth-container--mobile">
                        <NavbarAuth
                            user={user}
                            onLogout={handleLogout}
                            closeMenu={closeMenu}
                        />
                    </div>

                </div>

                <div className="navbar__navbarAuth-container--desktop">
                    <NavbarAuth
                        user={user}
                        onLogout={handleLogout}
                        closeMenu={closeMenu}
                    />
                </div>

                <div className="navbar__social navbar__social--desktop">
                    <a href="http://instagram.com/grandiretseleverensemble/"
                        className="navbar__social__link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {
                                error &&
                                <StrapiImageWithSkeleton
                                    url= '/assets/instagram.webp'
                                    altPicture= "Logo instagram"
                                    className='navbar__social__link__img'
                                    breakpoints={
                                        [
                                            { b: 0, w: '45px', h: '45px' },
                                            { b: 480, w: '32px', h: '32px' },
                                            { b: 1080, w: '40px', h: '40px' },
                                        ]
                                    }
                                />
                        }
                    </a>
                    <a href="https://www.facebook.com/grandiretseleverensemble/"
                        className="navbar__social__link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {
                            error &&
                                <StrapiImageWithSkeleton
                                    url='/assets/facebook.webp'
                                    altPicture="Logo facebook"
                                    className='navbar__social__link__img'
                                    breakpoints={
                                        [
                                            { b: 0, w: '45px', h: '45px' },
                                            { b: 480, w: '32px', h: '32px' },
                                            { b: 1080, w: '40px', h: '40px' },
                                        ]
                                    }
                                />
                        }
                    </a>
                </div>
            </div>
        </nav>
    );

    if (strapiData) return (
        <nav className="navbar">
            <div className="navbar__container">
                <div className="navbar__logo">
                    <NavLink
                        to="/"
                        className="navbar__logo_link"
                        onClick={closeMenu}
                    >
                        <StrapiImageWithSkeleton
                            picture={strapiData.Logo}
                            borderRadius='50%'
                            breakpoints={
                                [
                                    { b: 0, w: '59px', h: '59px' },
                                ]
                            }
                        />
                    </NavLink>
                </div>

                <button
                    className="navbar__burger"
                    onClick={toggleMenu}
                    aria-expanded={isMenuOpen}
                    aria-label="Menu principal"
                >
                    {isMenuOpen ? (
                        <SvgIcons name="close" width="36" height="36" color="#36152F" onClick={closeMenu}/>
                    ) : (
                        <SvgIcons name="burger_menu" width="48" height="48" color="#36152F" />
                    )}
                </button>

                <div className={`navbar__menu ${isMenuOpen ? 'active' : ''}`}>
                    <ul className='navbar__menu_navigation_list'>
                        {
                            strapiData.LienNavigation.map((menuItem, index) => (
                                <li
                                    key={index}
                                    className={`navbar__menu_navigation_item ${
                                        activeMenuIndex === index || isLinkActive(menuItem) ? 'active' : ''
                                    }`}
                                    onMouseEnter={() => {
                                        if (!isMobile) {
                                            displaySubMenu(menuItem, index);
                                            setActiveMenuIndex(index); // Active uniquement le menu survolé
                                        }
                                    }}
                                    onMouseLeave={() => {
                                        if (!isMobile) {
                                            hideSubMenu(menuItem, index);
                                            setActiveMenuIndex(null); // Désactive lorsqu'on quitte
                                        }
                                    }}
                                >
                                    <NavLink
                                        to={menuItem.LienNavigation === null ? '/' : '/' + menuItem.LienNavigation}
                                        className={
                                            isLinkActive(menuItem) ? "navbar__link active" : "navbar__link"
                                        }
                                        onClick={(e) => {
                                            closeMenu(e);
                                        }}
                                    >
                                        <span>{menuItem.TitreNavigation}</span>
                                        {
                                            menuItem.liste_ateliers_programme &&
                                            <svg
                                                ref={(e) => (chevronSubmenuRefs.current[index] = e)}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation(); // Empêche la propagation du clic au NavLink
                                                    displayOrHideSubMenuMobile(menuItem, index);
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={isMobile ? 25 : (isTab ? 20 : 25)}
                                                height={isMobile ? 25 : (isTab ? 20 : 25)}
                                                viewBox="0 -960 960 960"
                                                fill="currentColor"
                                            >
                                                <path strokeWidth='10px' stroke='currentColor' d="M622-136.5 278.5-480 622-823.5l29 28.5-315 315 315 314.5-29 29Z" />
                                            </svg>
                                        }
                                    </NavLink>
                                    {
                                        menuItem.liste_ateliers_programme &&
                                        <div ref={(e) => (submenuRefs.current[index] = e)} className='navbar__menu__dropdown_container'>
                                            <ul className='navbar__menu__dropdown'>
                                                {
                                                    menuItem.liste_ateliers_programme.Cartes_Atelier.map((subMenuItem, subIndex) => (
                                                        <React.Fragment key={subIndex}>

                                                            {   subMenuItem.Bouton.LienBouton &&
                                                                    (
                                                                        isExternalLink(subMenuItem.Bouton.LienBouton) ?
                                                                            <a
                                                                                href={subMenuItem.Bouton.LienBouton}
                                                                                className="navbar__menu__dropdown_item_link"
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <li
                                                                                    onClick={(e) => {
                                                                                        closeMenu(e);
                                                                                    }}
                                                                                    className='navbar__menu__dropdown_item'
                                                                                >
                                                                                    {subMenuItem.Titre1}
                                                                                </li>
                                                                            </a>
                                                                        :
                                                                            <NavLink
                                                                                to={'/' + subMenuItem.Bouton.LienBouton}
                                                                                className="navbar__menu__dropdown_item_link"
                                                                                
                                                                            >
                                                                                <li
                                                                                    onClick={(e) => {
                                                                                        closeMenu(e);
                                                                                        setSelectedMenuIndex(index); // Garde le menu principal actif
                                                                                    }}
                                                                                    className='navbar__menu__dropdown_item'
                                                                                >
                                                                                    {subMenuItem.Titre1}
                                                                                </li>
                                                                            </NavLink>
                                                                    )
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </ul>
                                            <div className='navbar__menu__dropdown__item_opacityBkg'></div>
                                        </div>
                                    }
                                </li>
                            ))
                        }
                    </ul>

                    <div className="navbar__social navbar__social--mobile">
                        {
                            strapiData.LienReseauSocial.map((socialItem) => (
                                <a
                                    key={socialItem.id}
                                    href={socialItem.LienNavigation}
                                    className="navbar__social__link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <StrapiImageWithSkeleton
                                        picture={socialItem.Icone}
                                        className='navbar__social__link__img'
                                        breakpoints={
                                            [
                                                { b: 0, w: '45px', h: '45px' },
                                                { b: 480, w: '32px', h: '32px' },
                                                { b: 1080, w: '40px', h: '40px' },
                                            ]
                                        }
                                    />
                                </a>
                            ))
                        }
                    </div>

                    <div className="navbar__navbarAuth-container--mobile">
                        <NavbarAuth
                            user={user}
                            onLogout={handleLogout}
                            closeMenu={closeMenu}
                        />
                    </div>

                </div>

                <div className="navbar__navbarAuth-container--desktop">
                    <NavbarAuth
                        user={user}
                        onLogout={handleLogout}
                        closeMenu={closeMenu}
                    />
                </div>

                <div className="navbar__social navbar__social--desktop">
                    {
                        strapiData.LienReseauSocial.map((socialItem) => (
                            <a
                                key={socialItem.id}
                                href={socialItem.LienNavigation}
                                className="navbar__social__link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <StrapiImageWithSkeleton
                                    picture={socialItem.Icone}
                                    className='navbar__social__link__img'
                                    breakpoints={
                                        [
                                            { b: 0, w: '45px', h: '45px' },
                                            { b: 480, w: '32px', h: '32px' },
                                            { b: 1080, w: '40px', h: '40px' },
                                        ]
                                    }
                                />
                            </a>
                        ))
                    }
                </div>
            </div>
        </nav>
    );
};
export default Navbar;